import { ProdFile, Product } from "../../../models/home-rows";
import { Attribute, Stars } from "../../../models/shared";

export interface ProductResponse extends Product {
  name_english?: string;
  price?: number;
  avatar?: Avatar;
  feature_avatar?: FeatureAvatar;
  short_description?: string;
  description?: string;
  promotions?: Promotion[];
  tags?: any[];
  categories?: Category[];
  comments_summery?: CommentsSummery[];
  custom_json?: any;
  root_categories?: RootCategory[];
  is_purchasable?: boolean;
  producer_id?: number;
  last_watched_file?: LastWatchedFile;
  is_series?: boolean;
  is_published?: boolean;
  language?: string;
  duration?: string;
  watch_length?: number;
  stars?: Stars[];
  files?: File[];
  products?: Product[];
  is_super?: boolean;
  is_renew?: boolean;
  has_sub?: boolean;
}

export type DownloadItemResponse  = {
    path: string;
    quality: string;
    size: number;
}

export interface CustomButton {
  title: string;
  background: string;
  text_color: string;
  stroke: string;
  is_visible: boolean;
  action: {
    type: number;
    data: string;
  }
  product?: ProductResponse;
}

export interface Avatar {
  xxxdpi: string;
  xxhdpi: string;
  xhdpi: string;
  hdpi: string;
  mdpi: string;
}

export interface FeatureAvatar {
  xxxdpi?: string;
  xxhdpi?: string;
  xhdpi?: string;
  hdpi?: string;
  mdpi?: string;
}

export interface Promotion {
  video: string;
  img: string;
  length?: number;
  banner?: boolean;
  video_link?: string;
  priority?: number;
}

export interface Avatars {
  xxxdpi: string;
  xxhdpi: string;
  xhdpi: string;
  hdpi: string;
  mdpi: string;
}

export interface Category {
  id: number;
  title_en: string;
  description: string;
  description_2: string;
  parent: number;
  is_default: boolean;
  title: string;
  avatars: Avatars;
  feature_avatar: FeatureAvatar2;
  position: number;
  show_type?: any;
  is_visible: boolean;
}

export interface CommentsSummery {
  score: number;
  count: number;
}

export interface Avatar2 {
  xxxdpi: string;
  xxhdpi: string;
  xhdpi: string;
  hdpi: string;
  mdpi: string;
}

export interface FeatureAvatar3 {
  xxxdpi: string;
  xxhdpi: string;
  xhdpi: string;
  hdpi: string;
  mdpi: string;
}

export interface File extends ProdFile {
  file?: any;
  preview?: string;
  img?: string;
  length?: number;
  file_type?: number;
  subtitles?: any[];
  animated_avatar?: string;
}

export interface Avatars2 {
  xxxdpi: string;
  xxhdpi: string;
  xhdpi: string;
  hdpi: string;
  mdpi: string;
}

export interface RootCategory {
  id: number;
  title_en: string;
  description: string;
  description_2: string;
  parent?: any;
  is_default: boolean;
  title: string;
  avatars: Avatars2;
  feature_avatar?: any;
  position: number;
  show_type?: any;
  is_visible: boolean;
}

export interface LastWatchedFile {
  id?: number;
  watch_length: number;
}

// export interface Product {
//   id: number;
//   name: string;
//   name_english: string;
//   product_type: number;
//   avatar: Avatar2;
//   feature_avatar: FeatureAvatar3;
//   is_purchasable: boolean;
// }

export interface SingleAttribute {
  language: string;
  "pre-title": string;
  "imdb-link"?: string;
}

export interface Avatar {
  xxxdpi: string;
  xxhdpi: string;
  xhdpi: string;
  hdpi: string;
  mdpi: string;
}
export interface Avatars {
  xxxdpi: string;
  xxhdpi: string;
  xhdpi: string;
  hdpi: string;
  mdpi: string;
}

export interface FeatureAvatar2 {
  xxxdpi: string;
  xxhdpi: string;
  xhdpi: string;
  hdpi: string;
  mdpi: string;
}

export interface Category {
  id: number;
  title_en: string;
  description: string;
  description_2: string;
  parent: number;
  is_default: boolean;
  title: string;
  avatars: Avatars;
  feature_avatar: FeatureAvatar2;
  position: number;
  show_type?: any;
  is_visible: boolean;
}

export interface CommentsSummery {
  score: number;
  count: number;
}

export interface Avatar2 {
  xxxdpi: string;
  xxhdpi: string;
  xhdpi: string;
  hdpi: string;
  mdpi: string;
}

export interface FeatureAvatar3 {
  xxxdpi: string;
  xxhdpi: string;
  xhdpi: string;
  hdpi: string;
  mdpi: string;
}
export interface Avatars2 {
  xxxdpi: string;
  xxhdpi: string;
  xhdpi: string;
  hdpi: string;
  mdpi: string;
}

export interface RootCategory {
  id: number;
  title_en: string;
  description: string;
  description_2: string;
  parent?: any;
  is_default: boolean;
  title: string;
  avatars: Avatars2;
  feature_avatar?: any;
  position: number;
  show_type?: any;
  is_visible: boolean;
}

export interface LastWatchedFile {
  id?: number;
  watch_length: number;
}

export interface UserComment {
  comment_text: string;
  score: number;
}

export class Comment {
  id: number = 0;
  title: string = "";
  score: number = 0;
  comment_text: string = "";
  likes: number = 0;
  dislikes: number = 0;
  user: string = "";
  date_added: string = "";
  comment_reply: any[] = [];
  user_avatar: string = "";
  product: number = 0;
  is_read: boolean = false;
  is_approved: boolean = false;
  product_name: string = "";
  date_modify: string = "";
}

export const PRODUCT_TYPES: { prod: string; id: number }[] = [
  { prod: "animations", id: 1 },
  { prod: "music", id: 2 },
  { prod: "collection", id: 3 },
  { prod: "game", id: 4 },
  { prod: "blog", id: 5 },
  { prod: "ugc", id: 7 },
  { prod: "quiz", id: 8 },
  { prod: "animations", id: 99 }
];

export const ROOT_CATEGORIES: { cat: string; id: number; title?: string }[] = [
  { cat: "en-learning", id: 247, title: "یادگیری زبان" },
  { cat: "school", id: 331, title: "مدرسه" },
  { cat: "kids", id: 223, title: "خردسال" },
  { cat: "game", id: 215, title: "بازی" },
  { cat: "music", id: 133, title: "رادیو" },
  { cat: "blog", id: 874, title: "بلاگ" }
];

export const ROOT_CATEGORIES_ID = {
  "en-learning": 247,
  game: 215,
  music: 133,
  school: 331,
  blog: 874
};
